import React from 'react';
import educations from '../data/education';

export default function Education() {
  return (
    <section id="education" className="py-6 px-6">
      <div className="slide-border-wrapper max-w-5xl mx-auto">
        <div className="slide-border-inner">
          <h3 className="text-3xl font-bold mb-4">Education</h3>
          {educations.map((edu, idx) => (
            <div key={idx} className="mb-6">
              <h4 className="text-xl font-semibold">{edu.degree} - {edu.school}</h4>
              <p className="text-gray-400 text-sm">{edu.location} | {edu.duration}</p>
              <ul className="list-disc list-inside text-gray-300 mt-2">
                {edu.tasks.map((task, i) => <li key={i}>{task}</li>)}
              </ul>

              {/* Tech stack badges */}
              {edu.tech && (
  <div className="flex flex-wrap gap-2 mt-3">
    {edu.tech.map((item, i) => {
      const Icon = item.icon;
      return (
        <span
          key={i}
          className={`text-white text-sm px-2.5 py-1 rounded-full flex items-center gap-2 ${item.color}`}
        >
          {Icon && <Icon className="text-base" />}
          {item.name}
        </span>
      );
    })}
  </div>
)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
